import * as _ from 'lodash-es';
import React from 'react';

const searchHighlight = (text: string, query: string) => {
  const regex = new RegExp(`(${_.escapeRegExp(query)})`, 'ig');

  return ''.match(regex)
    ? text
    : text.split(regex).map((part, index) =>
        // eslint-disable-next-line react/no-array-index-key
        part.match(regex) ? <strong key={index}>{part}</strong> : part,
      );
};

export default searchHighlight;
